<div class="paddedContent">
  @if (type == 'CreditCard') {
    <div>
      <div class="formRow">
        <app-ddl-input
          [label]="'Proposed processor'"
          [options]="processorOptions"
          [readonly]="false"
          [required]="true"
        />
      </div>
    </div>
  }

  @if (type == 'ACH') {
    <div>
      @if (type == 'ACH') {
        <div class="formSection">
          <div class="sectionHeader">ACH Information</div>
          <div class="formRow">
            <app-ddl-input
              [label]="'ACH Provider'"
              [options]="processorOptions"
              [readonly]="false"
              [required]="false"
            />
            <app-text-input
              [label]="'Max Daily Trans Count'"
              [type]="inputTextModes.Numeric"
              [readonly]="false"
              [required]="false"
            ></app-text-input>
            <app-text-input
              [label]="'Total # Transactions 14 days'"
              [type]="inputTextModes.Numeric"
              [readonly]="false"
              [required]="false"
            ></app-text-input>
          </div>
          <div class="formRow">
            <app-text-input
              [label]="'Max Single Trans Amount'"
              [type]="inputTextModes.CurrencyUSD"
              [readonly]="false"
              [required]="false"
            ></app-text-input>
            <app-text-input
              [label]="'Daily Max'"
              [type]="inputTextModes.CurrencyUSD"
              [readonly]="false"
              [required]="false"
            ></app-text-input>
            <app-text-input
              [label]="'Largest $ all trans in 14 days'"
              [type]="inputTextModes.CurrencyUSD"
              [readonly]="false"
              [required]="false"
            ></app-text-input>
          </div>
          <div class="formRow">
            <app-text-input
              [label]="'Refund Policy'"
              [readonly]="false"
              [required]="false"
            ></app-text-input>
          </div>
        </div>
      }
      <div class="formSection">
        <div class="sectionHeader">ACH pricing information</div>
        <div class="formRow">
          <app-text-input
            [label]="'Per Transaction'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
        </div>
        <div class="formRow">
          <app-text-input
            [label]="'Basis Points'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
          <app-text-input
            [label]="'Reversal Fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
          <app-text-input
            [label]="'Monthly Service Fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
          <app-text-input
            [label]="'Batch Fee'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
          <app-text-input
            [label]="'Return Item Fee (NSF)'"
            [type]="inputTextModes.CurrencyUSD"
            [readonly]="false"
            [required]="false"
          ></app-text-input>
        </div>
      </div>
    </div>
  }
  <!-- this is already on the solution tab
  <div class="formSection">
    <div class="sectionHeader">Company information</div>

    <div class="formRow">
      <app-text-input [label]="'Franchise Brand'" [readonly]="false" [required]="false"></app-text-input>
      <app-text-input [label]="'Operating Area(s) for DBA'" [readonly]="false" [required]="false"></app-text-input>
      <app-text-input [label]="'Target Open Date'" [type]="inputTextModes.Date" [readonly]="false" [required]="false"></app-text-input>
    </div>

    <div class="formRow">
      <app-text-input [label]="'Primary Business Ops'" [readonly]="false" [required]="false"></app-text-input>
      <app-text-input [label]="'Country Formed'" [readonly]="false" [required]="false"></app-text-input>
      <app-text-input [label]="'Year Established'" [type]="inputTextModes.Numeric" [readonly]="false" [required]="false"></app-text-input>
      (months) (years)
    </div>

    <div class="formRow">
      <app-text-input [label]="'DBA Fax'" [guidedFormat]="'111-111-1111'" [type]="inputTextModes.Phone" [readonly]="false" [required]="false"></app-text-input>
      <app-text-input [label]="'Mobile Phone'" [guidedFormat]="'111-111-1111'" [type]="inputTextModes.Phone" [readonly]="false" [required]="false"></app-text-input>
    </div>
  </div>
  -->

  <div class="formSection">
    <div class="sectionHeader">Statement/Chargebacks</div>

    <div class="formRow">
      <app-ddl-input
        [label]="'Statements Sent'"
        [options]="addressOptions"
        [readonly]="false"
        [required]="false"
      />
    </div>

    <div class="formRow">
      <app-check-input [label]="'Chargebacks'" [readonly]="false" />
      <app-text-input
        [label]="'Chargeback email'"
        [type]="inputTextModes.Email"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>

    <div class="formRow">
      <app-check-input [label]="'Retrievals'" [readonly]="false" />
      <app-text-input
        [label]="'Retrievals email'"
        [type]="inputTextModes.Email"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>
  </div>

  <div class="formSection">
    <div class="sectionHeader">Other Company Information</div>

    <div class="formRow">
      <app-ddl-input
        [label]="'Card Acceptance Type'"
        [options]="cardAcceptanceOptions"
        [readonly]="false"
        [required]="false"
      />
    </div>

    <div class="formRow">
      <!-- <app-text-input [label]="'Annual Volume'" [type]="inputTextModes.CurrencyUSD" [readonly]="false" [required]="false"></app-text-input> -->
      <app-text-input
        [label]="'Card Not Present'"
        [type]="inputTextModes.Percent"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Internet'"
        [type]="inputTextModes.Percent"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Manually Keyed - CP'"
        [type]="inputTextModes.Percent"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>

    <div class="formRow">
      <app-text-input
        [label]="'Average Sales Amount'"
        [type]="inputTextModes.CurrencyUSD"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Card Present'"
        [type]="inputTextModes.Percent"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>

    <div class="formRow">
      <app-text-input
        [label]="'Annual Revenue'"
        [type]="inputTextModes.CurrencyUSD"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Monthly CC Sales Volume'"
        [type]="inputTextModes.CurrencyUSD"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'High Sales Annually #'"
        [type]="inputTextModes.Numeric"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>

    <div class="formRow">
      <app-text-input
        [label]="'High Sales Amount'"
        [type]="inputTextModes.CurrencyUSD"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'B2B'"
        [type]="inputTextModes.Percent"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Card Swiped'"
        [type]="inputTextModes.Percent"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>

    <div class="formRow">
      <app-text-input
        [label]="'Manualy-Key- CNP/MOTO'"
        [type]="inputTextModes.Percent"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>

    <div class="formRow">
      <app-text-input
        [label]="'Description of Products'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>
    <div class="formRow">
      <app-text-input
        [label]="'Contact Us Email'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Customer Service Phone'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Customer Service Email'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>
  </div>

  <div class="formSection">
    <div class="sectionHeader">Banking Information</div>

    <div class="formRow">
      <app-text-input
        [label]="'Bank Name'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Routing Number'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Account Number'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>

    <div class="formRow">
      <app-ddl-input
        [label]="'Bank Account Type'"
        [options]="bankAccountTypes"
        [readonly]="false"
        [required]="false"
      />
      <app-ddl-input
        [label]="'Funding Option'"
        [options]="fundingOptions"
        [readonly]="false"
        [required]="false"
      />
    </div>

    <div class="formRow">
      <app-ddl-input
        [label]="'DDA Account Type #2'"
        [options]="bankAccountTypes"
        [readonly]="false"
        [required]="false"
      />
      <app-text-input
        [label]="'Routing Number'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Account Number'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-ddl-input
        [label]="'2nd Account Used For'"
        [options]="secondAccountUsageOptions"
        [readonly]="false"
        [required]="false"
      />
    </div>
  </div>

  <div class="formSection">
    <div class="sectionHeader">W9 Info</div>

    <div class="formRow">
      <app-text-input
        [label]="'Name on Tax Return'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>
  </div>

  <div class="formSection">
    <div class="sectionHeader">Principle Owners</div>

    <div>
      <input
        type="button"
        value="Add owner"
        (click)="btnAddOwner_click()"
        class="button_secondary button_var_2"
      />
    </div>
  </div>

  <div class="formSection">
    <div class="sectionHeader">Application Signer</div>

    <div class="formRow">
      <app-text-input
        [label]="'Full Name'"
        [helpText]="
          'This is just a sample of some help text that we could add to any field!'
        "
        [readonly]="false"
        [required]="true"
      ></app-text-input>
      <app-text-input
        [label]="'Email'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
      <app-text-input
        [label]="'Title'"
        [readonly]="false"
        [required]="false"
      ></app-text-input>
    </div>
  </div>
</div>
